module.exports = __webpack_public_path__ + "static/media/fish_zh.7231ed73.png";